import { toast } from "react-toastify";
import WhatsMarked from "react-whatsmarked";

// O WhatsMarked faz children.replace(...) direto: qualquer valor que não seja
// string derruba o render e o ErrorBoundary engole a tela inteira ("Ops! Algo
// deu errado"), fazendo o atendente perder a mensagem que estava digitando.
// Uma falha de envio tem que virar um aviso, nunca a tela branca.
const asText = (value) => {
	if (typeof value === "string") return value;
	if (value === null || value === undefined) return "";
	if (typeof value === "number" || typeof value === "boolean") return String(value);
	if (typeof value?.message === "string") return value.message;
	try {
		return JSON.stringify(value);
	} catch (_) {
		return "";
	}
};

const showToast = (texto, toastId) => {
	const msg = asText(texto) || "Ocorreu um erro inesperado.";
	try {
		toast.error(<WhatsMarked>{msg}</WhatsMarked>, { toastId: asText(toastId) || msg });
	} catch (_) {
		toast.error(msg, { toastId: asText(toastId) || msg });
	}
};

const toastError = (err, t) => {
	const translate = typeof t === "function" ? t : (key) => key;

	const errorMsg = asText(
		err?.response?.data?.message || err?.response?.data?.error
	);

	if (errorMsg) {
		const translatedMsgKey = `backendErrors.${errorMsg}`;
		const translated = asText(translate(translatedMsgKey));
		const translatedMsg = translated && translated !== translatedMsgKey ? translated : errorMsg;

		showToast(translatedMsg, errorMsg);
		return;
	}

	if (asText(err?.message)) {
		showToast(err.message, err.message);
		return;
	}

	const fallbackKey = "backendErrors.genericError";
	const translated = asText(translate(fallbackKey));
	const fallbackMsg = translated && translated !== fallbackKey ? translated : "An unexpected error occurred!";
	showToast(fallbackMsg, "genericError");
};

export default toastError;
